import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { TrackedIconButton as IconButton } from '../../../components/TrackedComponents';
import useDrivers from '../../../hooks/drivers';
import { DriverCardProps } from './DriverCard';

interface DriverModalHeaderProps {
    driver?: DriverCardProps;
    onClose: CallableFunction;
}

const DriverModalHeader: React.FC<DriverModalHeaderProps> = (props: DriverModalHeaderProps) => {
    const { getDriverFullName } = useDrivers();

    return (
        <Box
            sx={{
                backgroundColor: 'secondary.main',
                height: 40,
                minHeight: 0,
                position: 'sticky',
                top: 0,
                p: 1,
                zIndex: 3000,
            }}
        >
            <Box sx={{ position: 'absolute', display: 'flex', right: 0, top: 0, mt: 0.5, mr: 0.5 }}>
                <IconButton id="btn-close-modal" size="small" onClick={() => props.onClose()}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {!!props.driver ? (
                        <>
                            <PersonIcon sx={{ mr: 0.5 }} />
                            <Typography>
                                {`${getDriverFullName(props.driver.driver)}${
                                    !!props.driver.subFleet ? ` (${props.driver.subFleet})` : ''
                                }`}
                            </Typography>
                        </>
                    ) : null}
                </Box>
            </Box>
        </Box>
    );
};

export default DriverModalHeader;
